module.exports = __webpack_public_path__ + "img/840.a8e2e9a2.svg";